<template>
  <div class="home">
    <img class="FirstImg fade-in" alt="Ail" src="../../public/All.png">
    <router-link to="/about">
      <img v-if="image" :key="image.id" @click="switchImage" 
           class="image pulse" :src="image.src" :alt="image.alt" />
    </router-link>
    <img class="image1" src="../assets/Ellipse2.png" alt="">
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import image1 from "../assets/Ellipse.png";
import image2 from "../assets/buttonC.png"
export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  data(){
    return{
      index: 0,
      image: null,
      images: [{
          id: 1,
          src: image1,
          alt: "Image Normal"
        },
        {
          id: 2,
          src: image2,
          alt: "pressed"
        },
      ]
    }
  },
  mounted() {
    this.switchImage();
  },
  methods: {
    switchImage() {
      this.image = this.images[this.index];
      this.index = (this.index + 1) % this.images.length;
    }
  }
}
</script>
<style lang="scss">
// .FirstImg{
//   animation: reveal 3000ms ease-in-out forwards 200ms;
// }
// @keyframes reveal {
//     80%{
//       width: 58%;
//     }
//     100% {
//       width: 68%;
//     }
//   }
</style>

<style>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -45%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 20px 10px rgba(255, 255, 255, 0);
  }
}

.fade-in {
  animation: fadeIn 1.2s ease-out;
}

.pulse {
  animation: pulse 2s ease-in-out infinite;
}

.image {
  position: fixed;
  width: 70px;
  top: 80%;
  right: 5%;
  margin: 2px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  z-index: 100;
  touch-action: manipulation;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

.image1 {
  position: fixed;
  z-index: 50;
  width: 40px;
  top: 81%;
  right: 6%;
  margin: 2px;
  opacity: 0.9;
}

.image:hover,
.image:active {
  filter: brightness(1.3) drop-shadow(0 6px 12px rgba(255, 255, 255, 0.4));
  transform: scale(1.15) rotate(5deg);
}

.FirstImg {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 68%;
  max-width: 1200px;
  transition: all 0.4s ease;
  cursor: pointer;
  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.4));
}

.FirstImg:hover {
  filter: brightness(1.15) drop-shadow(0 15px 40px rgba(255, 255, 255, 0.3));
  transform: translate(-50%, -50%) scale(1.02);
}

/* Tablet */
@media (max-width: 1024px) {
  .FirstImg {
    width: 75%;
  }
  .image {
    width: 60px;
    right: 3%;
  }
  .image1 {
    width: 35px;
    right: 4%;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .FirstImg {
    width: 85%;
  }
  .image {
    width: 50px;
    top: 85%;
    right: 5%;
  }
  .image1 {
    width: 30px;
    top: 86%;
    right: 6%;
  }
}

@media (max-width: 480px) {
  .FirstImg {
    width: 90%;
  }
  .image {
    width: 45px;
    top: 88%;
  }
  .image1 {
    width: 28px;
    top: 89%;
  }
}
</style>
